export const COMPONENT_COLLAPSE_POINTS = {
	// when the number of portfolios is greater than this value we display components differently
	PAC_DEFAULT: 4,
	PC_DEFAULT: 4
};
